import React, {useRef} from "react";
import './ContactForm.css'
import emailjs from "@emailjs/browser";
export const ContactForm = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_5bb5h1d','template_ez6qzzh', form.current,'MTZ67r0-uOpmcjPZM').then(
            ()=>{
                alert("Message Sent successfully!");
                form.current.reset();
            },
            (error) => {
                alert("Failed to send message, please try again.", error.text)
            }
        )
    }


    return(
        <div className='form-wrapper'>
            <h2>Contact Me</h2>
            <form ref={form} onSubmit={sendEmail} className='contact-form'>
                <div className='form-group'>
                <label>Full Name</label>
                <input type="text" name="user_name" required placeholder="Your Full Name" />
                </div>

                <div className='form-group'>
                <label>Email</label>
                <input type='email' name='user_email' required placeholder="Your Email"/>
                </div>

                <div className='form-group'>
                <label>Subject</label>
                <input type="text" name="subject" required placeholder="Message Subject" />
                </div>

                <div className='form-group'>
                <label>Message</label>
                <textarea name='message' rows={4} columns={50} required placeholder="Your Message" />
                </div>
                <input type="submit" value="Send" />
            </form>
        </div>
    )
}